module.exports = __webpack_public_path__ + "img/instamoney.4b0a7704.jpeg";